import { supabase } from '@/lib/supabase';

/** Raw list_staples row from Supabase */
export interface ListStapleRow {
  id: string;
  list_id: string;
  user_id: string;
  item_name: string;
  category: string;
  is_custom: boolean;
  times_purchased: number;
  created_at: string;
}

/** Insert payload for list_staples table */
export type ListStapleInsert = {
  list_id: string;
  user_id: string;
  item_name: string;
  category: string;
  is_custom: boolean;
};

/**
 * Insert a new list staple (per user, per list).
 */
export function insertListStaple(row: ListStapleInsert) {
  // @ts-expect-error - Supabase client has no Database schema; insert expects typed rows
  return supabase.from('list_staples').insert(row).select().single();
}

/**
 * Delete a list staple by ID.
 */
export function deleteListStaple(stapleId: string) {
  return supabase.from('list_staples').delete().eq('id', stapleId);
}
